<template>
  <div class="form-floating" :class="classFloating">
    <slot v-bind="props">
      <component :is="ComponentForType">

      </component>
    </slot>

    <!-- <input :type="type" v-model="model" class="form-control " :class="classAttrs" placeholder="Jade"
      v-bind="props.attrs"> -->
    <slot name="label" v-bind="props">
      <label for="floatingInput">{{ props.label }}</label>
    </slot>

    <slot name="errors" v-bind="props">
      <small class="text-danger">{{ errors[name] }}</small>
    </slot>
    
  </div>
</template>

<script setup>


const props = defineProps({
  classFloating:{
    type:[String],
    default:'mb-1',
  },
  name:{
    type:String,
    required:true
  },

  type:{
    type:[String],
    default:'text'
  },

  size:{
    type:[String],
    default:'md'
  },

  placeholder:{
    type:String,
    default:''
  },

  label:{
    type:String,
    default:''
  },

  attrs:{
    type:[Array,Object],
    default: () => ({})
  },

  state:{
    type:Boolean,
    default:true
  },

  errors:{Array,Object}


})

const model = defineModel();
const {classFloating,type,size,state,errors,name} = toRefs(props);


const classAttrs = computed(() => {
  let sizes = ['sm', 'lg'];
  const rclass= [];
  if(sizes.includes(size.value)) rclass.push(`form-control-${size.value}`);
  !errors.value[name.value] ? rclass.push('is-valid') : rclass.push('is-invalid') ;

  return rclass;
});



const inputComponent = () => h('input',{type:props.type,placeholder:"Jade",value:model.value, onInput:($event) => model.value = $event.target.value ,class:['form-control',...classAttrs.value]});

const textareaComponent = () => h('textarea',
  {
    placeholder: "Jade",
    value: model.value, 
    onInput: ($event) => model.value = $event.target.value, 
    class: ['form-control', ...classAttrs.value],
    ...props.attrs
  }
);

const ComponentForType = computed(() => {
  if(['text','email','tel','search'].includes(props.type)) return inputComponent;
  if(['textarea'].includes(props.type)) return textareaComponent;
});

</script>

<style lang="scss" scoped>
// @import '@variables/variables';


// .form-floating > .form-control {
//   padding: 0rem !important;
//   min-height:2rem ;
//   height:2rem;
// }
</style>